import { graphql } from "relay-runtime"

export const deUpdateAllPatientAllergiesMutation = graphql`
  mutation deUpdateAllPatientAllergiesMutation($input: De_updateAllPatientAllergiesInput!) {
    updateAllPatientAllergies: de_updateAllPatientAllergies(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IcdCodeNotUnique {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      patientAllergiesOutput {
        id
        status
        allergies {
          comment
          icdDiagnosis {
            id
            isAssociation
            diagnosisCode
            primaryCode
            secondaryCode
            associationType
            text
          }
        }
      }
    }
  }
`
